import {
  Skeleton
} from "@livingdesign/react";
import React, { useState } from "react";
import MuiDataTable from "../../../../../components/Table/MuiDataTable/MuiDataTable";
import { amountFormat } from "../../../../../helpers/commonUtils";
import { overviewPhaseStyles } from "../OverviewPhase/OverviewPhase.styles";

const OverviewTenureTable = ({ breakdownData, loading }) => {
  const classes = overviewPhaseStyles();

  const tenureCustomBodyRender = (value, tableMeta) => {
    return <div id={`table-row-tenure-${tableMeta?.rowIndex}`}>{value}</div>
  }

  const staffCountCustomBodyRender = (value, tableMeta) => {
    return <div id={`table-row-staff-${tableMeta?.rowIndex}`}>{value || 0}</div>
  }

  const hoursCustomBodyRender = (value, tableMeta) => {
    return <div id={`table-row-hours-${tableMeta?.rowIndex}`}>{amountFormat(value) || 0}</div>
  }

  const budgetAmountCustomBodyRender = (value, tableMeta) => {
    return <div id={`table-row-budget-${tableMeta?.rowIndex}`} className={classes.amountStyle}>
      {value ? amountFormat(value) : "$0.00"}
    </div>
  }

  const effectiveRateCustomBodyRender = (value, tableMeta) => {
    return <div id={`table-row-rate-${tableMeta?.rowIndex}`} className={classes.amountStyle}>
      {value ? `$${amountFormat(value)}` : "$0.00"}
    </div>
  }

  const COLUMNS = [
    {
      name: "classification",
      label: "Tenure",
      colKey: "classification",
      options: {
        sort: true,
        customBodyRender: tenureCustomBodyRender
      },
    },
    {
      name: "dedicatedStaffCount",
      label: "# Dedicated Staff",
      colKey: "dedicatedStaffCount",
      options: {
        sort: true,
        customBodyRender: staffCountCustomBodyRender
      },
    },
    {
      name: "numberOfHours",
      label: "Hours",
      colKey: "numberOfHours",
      options: {
        sort: true,
        customBodyRender: hoursCustomBodyRender
      },
    },
    {
      name: "budgetAmount",
      label: "$ Amount",
      colKey: "budgetAmount",
      options: {
        sort: true,
        customBodyRender: budgetAmountCustomBodyRender
      },
    },
    {
      name: "effectiveRate",
      label: "$ Effective Rate",
      colKey: "effectiveRate",
      options: {
        sort: true,
        customBodyRender: effectiveRateCustomBodyRender
      },
    },
  ];

  const [breakdownColumns, setBreakdownColumns] = useState(COLUMNS);

  const customOptions = {
    responsive: "standard",
    totalCount: breakdownData?.length,
  };

  // Filter data to only show entries where effective rate > 0
  const filteredData = breakdownData?.filter(item => (item.effectiveRate > 0 || item.budgetAmount > 0 || item.dedicatedStaffCount > 0)) || [];

  // Calculate totals from filtered data
  const totals = filteredData.reduce((acc, item) => {
    acc.totalStaff += item.dedicatedStaffCount || 0;
    acc.totalHours += item.numberOfHours || 0;
    acc.totalAmount += item.budgetAmount || 0;
    return acc;
  }, { totalStaff: 0, totalHours: 0, totalAmount: 0 });

  const totalEffectiveRate = totals.totalHours > 0 ? (totals.totalAmount / totals.totalHours) : 0;

  // Add total row to filtered data
  const dataWithTotals = [
    ...filteredData,
    {
      id: "total",
      classification: "Total",
      dedicatedStaffCount: totals.totalStaff,
      numberOfHours: amountFormat(totals.totalHours),
      budgetAmount: amountFormat(totals.totalAmount),
      effectiveRate: amountFormat(totalEffectiveRate),
      isTotal: true
    }
  ];

  return (
    <div data-testid="BreakdownTable">
      <h3 className={classes.overviewTitleHead}>Breakdown by Tenure</h3>
      {!loading ?
        <>
          <div className={classes.dataTableWrap} data-testid="breakdown-list">
            <MuiDataTable
              data={dataWithTotals}
              columns={breakdownColumns}
              setTableColumns={setBreakdownColumns}
              customOptions={customOptions}
              onRowClick={() => {}}
              groupFilter={false}
              onExportClick={() => {}}
              onRowSelection={() => {}}
              onAddNew={() => {}}
              loading={loading}
              showRowsCounter={false}
              disableSearch={true}
              disableFilter={true}
              disablePagination={true}
              disableExport={true}
              hideAddNewButton={true}
            />
          </div>
        </>
        :
        <Skeleton height="20px" variant="rectangle" width="100%" />}
    </div>
  )
}

export default OverviewTenureTable;